{
  "title": "Synchronicity (UA)",
  "source": "Unearthed Arcana 7 - Modern Magic",
  "levelAndSchool": "4th-level enchantment (technomagic)",
  "level": 4,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "The creature you touch feels reality subtly shifted to its favor while this spell is in effect. The target isn't inconvenienced by mundane delays of any sort. Traffic lights are always green, there's always a waiting elevator, and a taxi is always around the corner. The target can run at full speed through dense crowds, and attacks of opportunity provoked by the target's movement are made with disadvantage.",
    "Synchronicity grants advantage to Dexterity (Stealth) checks, since the target always finds a handy piece of cover available. Additionally, the target has advantage on all ability checks made to drive a vehicle.",
    "In the event that two or more creatures under the effect of synchronicity are attempting to avoid being inconvenienced by each other, the creatures engage in a contest of Charisma each time the effects of the spells would oppose each other."
  ],
  "spellLists": ["arcane-trickster", "sorcerer", "warlock", "wizard"]
}
